<div class="container-timeline {{timeEntryPlace}}">
    <div class="content">
      <h4>{{timeEntryHeader}}</h4>
      <p>{{timeEntryContent}}</p>
    </div>
  </div>
